<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="hadoop">
          <ul>
            <li class="icon_a"><a href="#/cityBrain/socialSolutions">社会态势解决方案</a></li>
            <li class="icon_b actived"><a href="#/cityBrain/importantSolutions">重点防护解决方案</a></li>
            <li class="icon_c"><a href="#/cityBrain/warningSolutions">警情中心解决方案</a></li>
            <li class="icon_d"><a href="#/cityBrain/manySolutions">一标N实解决方案</a></li>
          </ul>
        </div>
      </div>
      <div class="solution">
        <div class="share">
          <div style="height:45px;width:415px;margin:0 auto;"><h2>重点防护解决方案</h2></div>
          <span></span>
        </div>
        <div class="view-tip">
          <p style="line-height:32px;font-size: 16px;color: #666;">运用三维建模技术，高精度、等比例还原重点目标和周边场景建筑三维模型，通过对重点区域出入口实时监控以及室内高精度定位，实现入侵告警、人流/车流趋势预判，重点人员关
注等功能，并为重大活动提供全方位立体布控及可视化预案。</p>
          <div class="detail" style="padding-left: 0px;">
            <div class="cityImg"><img src="../../../public/citybrianImg/city2.png" alt=""> </div>
          </div>
        </div>
        <div class="view-tip change">
          <p class="title">系统价值</p>
          <div class="detail">
            <ul>
              <li><span>全面防护</span><p>采用CAA（重点建筑还原）技术，细节层面1:1还原</p></li>
              <li><span>数字监控</span><p>实时接入各类感知数据，室内高精度定位，随时掌控安保情况</p></li>
              <li><span>可视化预案</span><p>采用可编辑沙盘功能实现重大活动精准预案，提升工作效率</p></li>
            </ul>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'城市大脑',
          detail:'City brain',
          src: require("../../../public/citybrianImg/citybrian.png"),
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
  .hadoop{
    position: absolute;
    width: 1200px;
    height: 150px;
    left:50%;
    transform: translateX(-50%);
    z-index: 99;
    margin-top:-75px ;
    background: url(../../../public/hadoopImg/hadoop.png) center;
    ul{
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      li{height: 40px;}
      .icon_a{
        background: url("../../../public/citybrianImg/icon_a.png")0px -2px no-repeat;
      }
      .icon_a:hover{
        background: url("../../../public/citybrianImg/icon_a1.png")0px -2px no-repeat;
      }
      .actived a{color: #01619E;}
      .icon_b{
        background: url("../../../public/citybrianImg/icon_b.png")0px -2px no-repeat;
      }
      .actived,.icon_b:hover{
        background: url("../../../public/citybrianImg/icon_b1.png")0px -2px no-repeat;
      }
      .icon_c{
        background: url("../../../public/citybrianImg/icon_c.png")0px -2px no-repeat;
      }
      .icon_c:hover{
        background: url("../../../public/citybrianImg/icon_c1.png")0px -2px no-repeat;
      }
      .icon_d{
        background: url("../../../public/citybrianImg/icon_d.png")0px -2px no-repeat;
      }
      .icon_d:hover{
        background: url("../../../public/citybrianImg/icon_d1.png")0px -2px no-repeat;
      }
      li:hover{
        color: #01619E;
      }
    }
    a{
      color: #333;
      padding-left: 50px;
    }
    a:hover,a:active{
      color: #01619E;
    }
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 5px;
          width: 326px;
        }
      }
    }
  }
.cityImg{
  img{
    width: 1200px;
    margin: 0 auto;
  }  
}
.solution{
  height: 1380px;
}
</style>


// WEBPACK FOOTER //
// src/views/cityBrain/importantSolutions.vue